<script lang="ts">
  import type { MetaInfo } from '$lib/types/metaInfo';

  export let metaInfo: MetaInfo;
</script>

<svelte:head>
  <title>{metaInfo.title}</title>
  {#each metaInfo.metaTags as tag}
    {#if ['description', 'keywords', 'robots'].includes(tag.key)}
      <meta name={tag.key} content={tag.value} />
    {/if}
    {#if tag.key.startsWith('og:') || tag.key.startsWith('twitter:')}
      <meta property={tag.key} content={tag.value} />
    {/if}
  {/each}

  <link rel="canonical" href={metaInfo.canonical} />

  <!-- Inject JSON-LD -->
  {@html `<script type="application/ld+json">${JSON.stringify(metaInfo.schemaGraph)}</script>`}
</svelte:head>
